// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'

import api from '@/api/public/index'
import md5 from 'js-md5';
import Bus from "@/assets/js/eventBus";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueClipboard from 'vue-clipboard2'
import JsonExcel from 'vue-json-excel'
import 'babel-polyfill'
import '@/icons';
import Vant, {Lazyload} from 'vant';
import 'vant/lib/index.css';
import utilsPublic from "./utils/public";
import wow from 'wowjs'
import 'animate.css'
import "@/assets/css/common.css"
// import 'highlight.js/styles/github.css'; // GitHub风格的主题样式
import 'highlight.js/styles/atom-one-dark.css'; // GitHub风格的主题样式

Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$md5 = md5;
Vue.prototype.$utilsPublic = utilsPublic;
Vue.prototype.$wow = wow;

Vue.use(Bus); 
Vue.use(ElementUI);
Vue.use(VueClipboard);
Vue.component('downloadExcel', JsonExcel);
Vue.use(Vant);
Vue.use(Lazyload);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js